import { createAction, props } from '@ngrx/store';
import { CommunityProduct } from '../../models/community-product.model';


export const loadIndividualProducts = createAction(
  '[Product] Load Individual Products',
  props<{ categoryId?: string; subRegionId?: any; search?: any; page?: number; basedProduct?: string; isPopular?: boolean; orderBy?: string, loadTags?: boolean }>()
);
export const loadIndividualProductsSuccess = createAction(
  '[Product] Load Individual Products Success',
  props<{ individualProducts: CommunityProduct[] }>()
);
export const loadIndividualProductsFailure = createAction(
  '[Product] Load Individual Products Failure',
  props<{ error: any }>()
);
